const SETTINGS_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  PAYMENT_TYPE: 'paymentType',
  USER_ID: 'userId'
}

const SETTINGS_MODEL_PRIVATE_KEYS = []

export { SETTINGS_MODEL_PRIVATE_KEYS }

export { SETTINGS_MODEL_KEY }
const SETTINGS_MODEL_CLASS_NAME = 'Settings'

export { SETTINGS_MODEL_CLASS_NAME }

const SETTINGS_MODEL_SCOPE = {

  /**
   * Only returns the public attributes of a `Settings`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: SETTINGS_MODEL_PRIVATE_KEYS
    }
  }

}

export { SETTINGS_MODEL_SCOPE }
